<template>
  <div @click.capture.prevent="handleClick">
    <AtomLink
      v-if="child.title && child.url"
      :url="child.url"
      class="group flex flex-row items-center hover:bg-app-primary-grey--black-squeeze transform transition duration-200 rounded-br-2xl group mega-menu-item h-full"
      :class="{ 'px-6 py-4': !small }"
      :title="child.title"
      data-component="CardMenuCategory"
    >
      <div v-if="child.image" class="w-[77px] h-[77px] rounded-xl overflow-hidden mr-4 shrink-0">
        <MoleculePicture :image="child.image" alt="" :aria-hidden="true" />
      </div>
      <div class="mr-4">
        <h3 class="text-app-primary-1-red--torch group-hover:text-app-primary-1-red--fire-brick transform transition duration-200" :class="{ 'mb-1': small }">
          {{ child.title }}
        </h3>
        <h4 v-if="child.subtitle" class="text-sm leading-5">
          {{ child.subtitle }}
        </h4>
      </div>
      <div class="shrink-0 ml-auto">
        <AtomIconArrowRight
          class="w-4 h-4 text-app-primary-1-red--torch group-hover:text-app-primary-1-red--fire-brick transform transition duration-200 group-hover:translate-x-1"
        />
      </div>
    </AtomLink>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  child: {
    type: Object as PropType<Record<string, any>>,
    required: true,
  },
  small: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits(['toggleMenu', 'navigationClick'])

const router = useRouter()

function resolveTo(url?: CmsData | string | null) {
  if (typeof url === 'object') {
    return url
  }

  try {
    const parsed = new URL(String(url), window.location.origin)

    if (parsed.origin !== window.location.origin) {
      return null
    }

    return parsed.pathname + parsed.search + parsed.hash
  } catch {
    return url
  }
}

function handleClick() {
  emit('toggleMenu')
  emit('navigationClick', props.child.title)

  // This gives the navigationClick event time to run before the page changes
  setTimeout(() => {
    const to = resolveTo(props.child.url)

    if (to) {
      router.push(to)
    } else {
      window.location.assign(props.child.url)
    }
  }, 50)
}
</script>
